import React from 'react'
import { Button, TextField } from '@material-ui/core'
import { isBrowser } from 'react-device-detect'

export function TextboxControl( { preg, handleChange, classes } ) {

    console.log('TextboxControl')
    return (
        <div className={ isBrowser ? "ed-grid s-grid-2 m-grid-6 lg-grid-12" : "ed-grid rows-gap s-gap-1 s-grid-2 m-grid-6 lg-grid-12" }>
            <div className="s-y-1 s-x-1 s-cols-2 
                            m-y-1 m-x-1 m-cols-6
                            l-y-1 l-x-1 l-cols-12">
                <div className={ classes.wrapper }>
                    <TextField
                    className={ classes.inputStyle} 
                    fullWidth
                    autoComplete="off"
                    size="small"
                    label="Respuesta"
                    variant="outlined"
                    helperText="Cantidad máx. de caracteres permitidos: 500"
                    name={ preg.ID }
                    value={ preg.RESPUESTA[0] }
                    inputProps={ { maxLength: 500 } }
                    multiline={ preg.TIPO_RPTA_COD == 7 }
                    rows={ preg.TIPO_RPTA_COD == 7 && 4 }
                    onChange={ ( e ) => handleChange( e, preg.ID ) }
                    />
                </div>
            </div>
        </div>

    )
}
